"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _editorialContentGrid = require("@mmc/editorial-content-grid");

var _editorialXlCards = require("@mmc/editorial-xl-cards");

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _highLow = _interopRequireDefault(require("./layouts/high-low"));

var _medium = _interopRequireDefault(require("./layouts/medium"));

var _large = _interopRequireDefault(require("./layouts/large"));

var _editorialCards = _interopRequireDefault(require("./editorial-cards.props/editorial-cards.defaultProps"));

var _editorialCards2 = _interopRequireDefault(require("./editorial-cards.props/editorial-cards.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * ## EditorialCards - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var layoutMap = {
  highlow: _highLow["default"],
  medium: _medium["default"],
  large: _large["default"],
  extralarge: _editorialXlCards.EditorialXlCards,
  contentgrid: _editorialContentGrid.EditorialContentGrid
};

var EditorialCards = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(EditorialCards, _React$Component);

  // All components need a resourceType in order for AEM to be aware of its existance
  EditorialCards.resourceType = function resourceType() {
    return 'EditorialCards_1_0_0';
  };

  function EditorialCards(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.getAlignment = _this.getAlignment.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = EditorialCards.prototype;

  _proto.getAlignment = function getAlignment(textAlignment) {
    // check against expected values defaulting to left align
    var themeAlignment;

    if (textAlignment === 'center') {
      themeAlignment = 'center';
    } else if (textAlignment === 'right') {
      themeAlignment = 'end';
    } else {
      themeAlignment = 'start';
    }

    return themeAlignment;
  };

  _proto.getProps = function getProps(layout, normal, data) {
    return layout === 'extralarge' || layout === 'contentgrid' ? data : normal;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData,
        market = _this$props.market;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var editorialLayout = componentData.editorialLayout,
        columns = componentData.columns,
        textAlignment = componentData.textAlignment,
        disclaimerData = componentData.disclaimerData,
        addPriceDisclaimer = componentData.addPriceDisclaimer,
        priceDisclaimerId = componentData.priceDisclaimerId;
    var themeAlignment = this.getAlignment(textAlignment);
    var Layout = layoutMap[editorialLayout];
    var normalProps = {
      theme: theme,
      columns: columns,
      editorialLayout: editorialLayout,
      themeAlignment: themeAlignment,
      disclaimerData: disclaimerData,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      market: market
    };
    var dataProps = {
      data: data,
      theme: theme,
      market: market
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Layout, this.getProps(editorialLayout, normalProps, dataProps)));
  };

  return EditorialCards;
}(_react["default"].Component);

EditorialCards.displayName = 'EditorialCards';
EditorialCards.defaultProps = {
  data: _editorialCards["default"],
  defaultData: _editorialCards["default"]
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    market: state.Config.market
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(EditorialCards));

exports["default"] = _default;